// extracted by mini-css-extract-plugin
export var btn = "style-guide-components-module--btn--6Ivc3";
export var component = "style-guide-components-module--component--BCG1w";
export var componentVariation = "style-guide-components-module--component-variation--E8K3p";
export var darkBackground = "style-guide-components-module--dark-background--bVBEf";